module.exports = __webpack_public_path__ + "img/skiing_1413_1.b08428a1.jpg";